module.exports = __webpack_public_path__ + "img/logo.59615e1b.png";